<template>
  <div>
    <div class="col-md-12 mt-4 mb-4">
      <div class="d-flex flex-column mb-4 custom-border">
      </div>
    </div>
    <div
      class="d-flex align-items-center cursor-pointer icon-container "
      v-b-toggle.technician-form
    >
      <div class="icon-wrapper">
        <transition name="fade">
          <b-icon-caret-down-fill  v-if="isOpen" key="down" class="icon"></b-icon-caret-down-fill>
          <b-icon-caret-right-fill  v-else key="right" class="icon"></b-icon-caret-right-fill>
        </transition>
      </div>
      <div class="bold-text profil-subsection">{{ $t('Profile.technician.data') }}</div>
    </div>

    <b-collapse id="technician-form" v-model="isOpen">
      <div class="d-flex flex-column">
        <b-form @submit.stop.prevent="onSubmit">
          <div class="row mt-4">
            <div class="col-md-12">
              <dropdown-department :departments="departments"  :department="this.form.department"></dropdown-department>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button tabindex="2" type="submit" variant="primary">{{$t('Validate')}}</b-button>
          </div>
        </b-form>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import DropdownDepartment from "../../../components/b122/DropdownDepartment";
import api from "../../../services/api";
import {bus} from "../../../main";
export default {
  name: "MineTechnicianEdit",
  components:{
    DropdownDepartment
  },
  props:{
    technicianId:Number,
  },
  data() {
    return {
      isOpen: false,
      departments: [],
      form: {
        department: {
          state: null,
          invalidFeedback: null,
          values: [],  // To hold multiple selected values
          options: [],  // List of all possible department options
        },
      },
      isLoading:true,
      technician:{}
    };
  },

  watch: {
    async isOpen(newVal) {
      if (newVal) {
        this.isLoading = true
        await this.fetchAllDepartments();
        await this.fetchTechnician()
        this.isLoading = false
      }
    }
  },

  methods:{
    async fetchAllDepartments () {
      await api
        .get('/technician/getAllDepartments/')
        .then(response => {
          this.departments = response.data.map(dept => {
            return {
              text: dept.tostring,
              value: dept.id
            }
          });

          this.form.department.options = this.departments
        });
    },

    async fetchTechnician(){
        this.isLoading=true
        api
          .get(`/technician/getTechnicianProfile/`+this.technicianId)
          .then(response => {
            this.technician=response.data
            this.form.department.value = this.technician.department
            this.form.department.values = this.formatDepartment(this.technician.department);
          })
          .catch((error) => {
           this.isOpen=false
          })
    },

    formatDepartment(value){
      return value.map(item => Number(item.id));
    },

    async onSubmit () {
      let data = new FormData()
      if(!this.technicianId){
        this.isOpen=false
        return
      }
      data.append('department', this.form.department.values)
      data.append('id', String(this.technicianId))

      await api({
        method: 'post',
        url: '/technician/updateTechnicianProfile',
        data:data
      })
        .then((response) => {
          this.isOpen=false
          this.technician=response.data
          this.$nextTick(() => {
            this.successToast(this.technician.tostring)
          })
        })
        .catch((error) => {
          this.isOpen=false
        })
    },

    successToast (taskName) {
      this.$bvToast.toast(this.$i18n.t('Technician') + ' "' + taskName + '" ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    },
  },
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.icon-container {
  position: relative;
}

.icon-wrapper {
  position: relative;
  width: 24px; /* Ajustez la largeur en fonction de la taille de l'icône */
  height: 14px;
}

.icon {
  position: absolute;
  top: 0;
  left: 0;
}
</style>





// WEBPACK FOOTER //
// src/views/user/profileEdit/MineTechnicianEdit.vue